// extracted by mini-css-extract-plugin
export default {"badge":"iconbadge_badge__tjpW-","badge__count":"iconbadge_badge__count__8M0xe","badge__icon":"iconbadge_badge__icon__zv0ON"};